var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{domProps:{"innerHTML":_vm._s(_vm.getTextByValue(_vm.value, _vm.model))}})
}
var staticRenderFns = []

export { render, staticRenderFns }